<template>
  <div>
    <CRow>
      <CCol sm="12">&nbsp;<br/></CCol>
      <CCol sm="12">
        <GlobalTable
          :title="'Generate Password'"
          :fields="fields"
          :items="data"
          :enableAddButton="false"
          :editButton="true"
          :redirectDetail="false"
          :isLoading="isLoading"
          :withCard="false"
          @addForm="addForm"
          @editForm="editForm"
        ></GlobalTable>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">{{ title }}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CRow>
          <CCol sm="3">
            <CInput
              label="Password"
              type="password"
              invalid-feedback="Password should be filled"
              required
              v-model="$v.generatePasswordForm.password.$model"
              :is-valid="!$v.generatePasswordForm.password.$invalid"
            />
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.generatePasswordForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import GlobalTable from "@/templates/Table";

import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

export default {
  name: "GeneratePassword",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "Add Form Generate Password",
      items: [],
      addButton: false,
      isEdit: false,
      generatePasswordForm: tableInterfaces.generate_password,
      isLoading: false,
      activeTab: 0,
      //   checkedFlag: "Agent",
      fields: [
        { key: "user_code", label: "User Code", sorter: true },
        { key: "password", label: "Password", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
    };
  },
  props: {
    agent: {
      type: [Array, Object],
      default: () => [],
    },
    provinceList: {
      type: [Array, Object],
      default: () => [],
    },
    agentPassword: {
      type: [Array, Object],
      default: () => [],
    },
    userCode: {
      type: String,
      default: null,
    },
  },
  validations: {
    generatePasswordForm: {
      id: {},
      password: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    data: function () {
      return this.items.length > 0 ? this.items : this.agentPassword;
    },
  },
  methods: {
    init: function () {
      this.refreshUserPassword(this.userCode)
    },
    refreshUserPassword: function (user_code) {
      this.isLoading = true;
      this.axios
        .get("console/users/user_password/listing/" + user_code)
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.isEdit = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.title = "Edit Password";
      this.isEdit = true;
      this.resetForm();
      this.addButton = true;
      this.generatePasswordForm.id_user_password = item.id;
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    resetForm: function () {
      for (var i in tableInterfaces.generate_password) {
        tableInterfaces.generate_password[i] = null;
      }
      this.generatePasswordForm = tableInterfaces.generate_password;
    },
    back: function () {
      this.$router.go(-1);
    },
    submitForm: function (event) {
      event.preventDefault();
      this.generatePasswordForm.user_code = this.userCode;
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put(
              "console/users/update-password",
              this.generatePasswordForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.cancelForm();
              this.refreshUserPassword(this.userCode);
            });
        }
      
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
